import apiProvider from './provider';
import {
  getAuthenticationHeaders,
  getErrorMessage,
  getFileExtension,
  dataHeaders,
} from './utils';
import { API_BASE_URL } from '../globals';
import {
  GET_MANIFEST_UPLOAD_S3_LINK,
  GET_S3_PUT_CERTIFICATE_OBJECT,
  GET_S3_PUT_OBJECT,
  EDIT_PASSWORD_POLICY_IMAGE
} from './routes';
import { message } from 'antd';
export const addFileToSignedUrl = async (putObject: any, file: File) => {
  try {
    const response = await apiProvider.put(putObject.imageSignedUrl, file, {
      headers: {
        'Content-Type': dataHeaders[getFileExtension(file).toUpperCase()],
      },
    });
    return {
      data: response.data,
      url: putObject.imageUrl,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const addPDFFileToSignedUrl = async (putObject: any, file: File) => {
  try {
    const signedUrl = putObject.imageSignedUrl || putObject.fileSignedUrl;
    const url = putObject.imageUrl || putObject.fileUrl;
    const response = await apiProvider.put(signedUrl, file, {
      headers: {
        'Content-Type': 'application/pdf',
      },
    });
    return {
      data: response.data,
      url,
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getS3SignedUrlAndUpload = async (file: File) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${GET_S3_PUT_OBJECT}`,
      {
        fileType: dataHeaders[getFileExtension(file).toUpperCase()],
      },
      {
        headers: await getAuthenticationHeaders(),
      },
    );
    const imageUpload = await addFileToSignedUrl(response.data, file);
    return imageUpload;
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getS3SignedUrlAndUploadImage = async (file: File) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${EDIT_PASSWORD_POLICY_IMAGE}`,
      {
        fileType: dataHeaders[getFileExtension(file).toUpperCase()],
        fileName: file.name
      },
      {
        headers: await getAuthenticationHeaders(),
      },
    );
    if ( !(response?.data) ){
      return {
        errorMessage: 'Unable to upload image.',
        isSuccess: false,
      };
    }
    const imageUpload = await addFileToSignedUrl(response.data, file);
    return imageUpload;
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
}

export const getS3SignedCertificateUrlAndUpload = async (
  file: File,
  params?: any,
) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${GET_S3_PUT_CERTIFICATE_OBJECT}`,
      {
        fileType: file.type,
        fileName: file.name,
        ...params,
      },
      {
        headers: await getAuthenticationHeaders(),
      },
    );
    const imageUpload = await addPDFFileToSignedUrl(response.data, file);
    return imageUpload;
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getS3LinkForManifestUpload = async (
  file: File,
  docReferenceId,
) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${GET_MANIFEST_UPLOAD_S3_LINK}`,
      {
        fileName: file.name,
        docReferenceId,
      },
      {
        headers: await getAuthenticationHeaders(),
      },
    );
    const imageUpload = await addPDFFileToSignedUrl(response.data, file);
    return imageUpload;
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
